export default __webpack_public_path__ + "static/media/out.eec73d1a.PNG";